import React from 'react';
import { Button, Spinner, ButtonProps } from 'react-bootstrap';

interface Props extends React.PropsWithChildren, ButtonProps {
    loading?: boolean;
}

// Extended the Button component from bootstrap, just to add
// a loading state with spinner and just pass a boolean to control it
const ButtonComponent: React.FC<Props> = ({
    loading = false,
    children,
    ...props
}) => {
    return (
        <Button
            {...props}
            disabled={loading}
        >
            {children} 
            {loading && <Spinner animation="border" role="status" size="sm" className="ms-1" />}
        </Button>
    );
};

export default ButtonComponent;